// src/pages/Ideen/Ideen.jsx
import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Container,
  SimpleGrid,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { Link } from "react-router-dom"; // ✅ Wichtig!
import { getIdeen, deleteIdee } from "../../service/api";

const Ideen = () => {
  const [ideen, setIdeen] = useState([]);
  const [message, setMessage] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    getAllIdeen();
  }, []);

  const getAllIdeen = async () => {
    const response = await getIdeen();
    setIdeen(response.data || []);
  };

  const deleteIdeeFromCollection = async (id) => {
    const confirmDelete = window.confirm("Soll die Idee wirklich aus der Sammlung entfernt werden?");
    if (!confirmDelete) {
	 setMessage("Aktion abgebrochen");
     onOpen();
     getAllIdeen();	 
     return; // Abbruch – nichts löschen
    }
	
	const response = await deleteIdee(id);
    setMessage(response.data?.message || "Aktion abgeschlossen");
    onOpen();
    getAllIdeen();
  };

  return (
    <Container maxW="container.md" py={8}>
      <Heading textAlign="center" mb={6}>
        Ideensammlung
      </Heading>

      <VStack spacing={6}>
        {ideen.length > 0 ? (
          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4} w="100%">
            {ideen.map((idee) => (
              <Box
                key={idee.id}
                bg="gray.50"
                border="1px solid"
                borderColor="gray.200"
                p={4}
                borderRadius="lg"
                shadow="sm"
                _hover={{ shadow: "md" }}
                wordBreak="break-word"
              >
                <Heading as="h3" size="md" mb={2}>
                  {idee.kurzfassung}
                </Heading>
                <Text whiteSpace="pre-wrap">{idee.idee}</Text>

                <HStack justify="space-between" mt={4} flexWrap="wrap">
                  <VStack align="start" spacing={0}>
                    <Text color="gray.600" fontSize="sm">
                      von: {idee.von}
                    </Text>
                    <Text color="gray.500" fontSize="sm">
                      Datum: {idee.datum}
                    </Text>
                  </VStack>

                  <HStack spacing={2} mt={{ base: 2, sm: 0 }}>
                    <Button
                      as={Link} // ✅ React Router Navigation
                      to={`/ideen/editIdee/${idee.id}`}
                      colorScheme="teal"
                      size="sm"
                    >
                      Ändern
                    </Button>
                    <Button
                      colorScheme="red"
                      size="sm"
                      onClick={() => deleteIdeeFromCollection(idee.id)}
                    >
                      Entfernen
                    </Button>
                  </HStack>
                </HStack>
              </Box>
            ))}
          </SimpleGrid>
        ) : (
          <Box p={6} bg="gray.50" borderRadius="md" textAlign="center">
            <Text mb={3}>Noch keine Ideen vorhanden.</Text>
            <Button
              as={Link} // ✅ Hier auch!
              to="/ideen/addIdee"
              colorScheme="teal"
              size="md"
              bgGradient="linear(to-r, teal.500, blue.400)"
              _hover={{ bgGradient: "linear(to-r, teal.600, blue.500)" }}
            >
              Neue Idee hinzufügen
            </Button>
          </Box>
        )}

        {/* 🔹 Immer sichtbarer Button unter der Liste */}
        {ideen.length > 0 && (
          <Button
            mt={4}
            as={Link}
            to="/ideen/addIdee"
            colorScheme="teal"
            bgGradient="linear(to-r, teal.500, blue.400)"
            _hover={{ bgGradient: "linear(to-r, teal.600, blue.500)" }}
          >
            Neue Idee hinzufügen
          </Button>
        )}
      </VStack>

      {/* 🔹 Modal für Rückmeldung */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Status</ModalHeader>
          <ModalBody>
            <Text>{message}</Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Schließen</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default Ideen;
